import { Component, Inject } from '@angular/core';
import { Constant } from './../../constant';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonUtil } from '../../util/common-util';
import { ToastUtil } from '../../util/toast-util';
import { Auth } from '@aws-amplify/auth';
import { AuthService } from './../../auth/auth.service';

@Component({
    selector: 'app-account-edit-dialog',
    templateUrl: './account-edit-dialog.component.html',
    styleUrl: './account-edit-dialog.component.css',
    standalone: false
})
export class AccountEditDialogComponent {
  public readonly Constant = Constant;
  public form: FormGroup;
  public isSaving = false;
  public maxLenColor = 6
  //public mainColor
  public colorPreviewId = 'main-color-preview'
  private apiPath = '/account';
  public auths;
  public accountAuth;
  public mailaddress;
  public account;
  public showSpinner = true;
  public currentAuth;
  public loginAuthCode: number;
  constructor(
    public dialogRef: MatDialogRef<AccountEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private auth: AuthService,
    private commonUtil: CommonUtil,
    private toastUtil: ToastUtil,
  ) {
    //this.mainColor = data.mainColor
    this.auths = [
      { label: '管理', value: '0' },
      { label: '準管理', value: '1' },
      { label: '運用', value: '2' },
      { label: 'メンバー', value: '3' },
      { label: 'なし（未承認）', value: '4' }
    ];
    this.loginAuthCode = Number(this.auth.getAuthCode());
    //const loginAuthCode = this.auth.getAuthCode();
    if (this.loginAuthCode !== 0) {
      this.auths = this.auths.filter(auth => Number(auth.value) > this.loginAuthCode);
    }
  }

  getAuthLabel(value: number | string) {
    const item = [
      { label: '管理', value: '0' },
      { label: '準管理', value: '1' },
      { label: '運用', value: '2' },
      { label: 'メンバー', value: '3' },
      { label: 'なし（未承認）', value: '4' }
    ].find(a => a.value === String(value));

    return item?.label ?? '';
  }


  ngOnInit() {
    if (this.data.id !== 0) {
      this.getDetail();
    } else {
      this.account = {
        mailaddress: Constant.empty,
        accountAuth: Constant.empty,
      };
      this.initForm()
      this.showSpinner = false;
    };
  }

  onSave() {
    if (!this.commonUtil.checkOnline()) {
      this.isSaving = false;
      return;
    }

    if (this.isSaving) {
      return;
    }

    this.isSaving = true;
    if(this.data.id !== 0){
      this.dataUpdate();
    }
  }

  onInput() {
    const mail_address = this.form.value.mail_address;

    if (mail_address.length < 6) {
      return
    }

  }

  onChange() {
    const auth = this.form.value.accountAuth;

    if (auth.length < 6) {
      return
    }

  }

  onCompositionEnd() {
    this.onInput()
  }

    /* プライベート */
  // 詳細取得
  private getDetail() {
    if (!this.commonUtil.isOnline()) {
      this.toastUtil.showErrorToast(Constant.empty, Constant.msgNetworkError, Constant.toastShowMiliSec);
      this.dialogRef.close();
      return;
    }

    Auth.currentSession().then(session => {
      const apiPath = this.apiPath + '/detail/' + this.data.id;
      const options = this.auth.createApiHeader(session);
      this.commonUtil.apiGet(apiPath, options).then(res => {
        if (!res.data) {
          // 削除済み
          this.toastUtil.showErrorToast(Constant.empty, Constant.msgDeleteAccountAlreadyError, Constant.toastShowMiliSec);
          this.dialogRef.close(true);
          return;
        }
        this.account = res.data;
        this.initForm();
        this.showSpinner = false;
      })
      .catch(err => {
        this.commonUtil.debug().log(err);
        if (err.message === Constant.msgLoginFailed) {
          this.commonUtil.showReloadDialog(this.auth);
        } else {
          this.toastUtil.showErrorToast(Constant.empty, Constant.msgNetworkError, Constant.toastShowMiliSec);
          this.dialogRef.close();
        }
      });
    });
  }

  private initForm() {
    this.form = new FormGroup({
      mailaddress: new FormControl(this.account.user_id, [Validators.required]),
      accountAuth: new FormControl(
        String(this.account.user_authority),
        Validators.required
      ),
    });
    this.currentAuth = this.form.get('accountAuth')?.value;
    //this.form.get('mailaddress')?.disable({ emitEvent: false });
  }

  // 登録実行
  private dataUpdate() {
    Auth.currentSession().then(session => {
      const options = this.auth.createApiHeader(session);
      options['body'] = {
        user_id: this.account.user_id,
        user_authority: this.form.value.accountAuth
      };
      console.log(options)
      this.commonUtil
        .apiPut(this.apiPath + '/auth', options)
        .then(res => {
          if (res.status === Constant.OK) {
            this.toastUtil.showInformationToast('', Constant.msgResultChangerUserAuthSuccess, Constant.toastShowMiliSec);
            this.dialogRef.close(res.status);
          }
        })
        .catch(err => {
          this.commonUtil.debug().log(err);
          if (err.message === Constant.msgLoginFailed) {
            this.commonUtil.showReloadDialog(this.auth);
          } else if(err.message == "対象のユーザーが存在しません。") {
            this.toastUtil.showErrorToast('', Constant.msgDeleteAccountAlreadyError, Constant.toastShowMiliSec);
            this.dialogRef.close(Constant.NG);
          } else {
            this.toastUtil.showErrorToast('', Constant.msgSaveFailedRetry, Constant.toastShowMiliSec);
          }
          this.isSaving = false;
        });
    });
  }
}
